<div class="container-fluid box-sub-header py-3 pt-lg-5">
  @if (suggestedProposals?.length > 0 && enabledSuggestedProposalsButton) {
  <button class="anonymize-button" (click)="showSuggestedProposals()">
    {{ 'components.responses.view-suggested-proposals' | translate }}
  </button>
  }
  <div class="container">
    <!-- Sezione alert -->
    @if (!loading) {
    @if (decision_table?.closing_date) {
    <mat-card class="my-3" style="background-color: red; color: white;">
      {{ 'components.responses.decision-table-closed' | translate }}
    </mat-card>
    }
    @if (!evaluation_session?.collecting && !decision_table?.closing_date) {
    <mat-card class="my-3" style="background-color: red; color: white;">
      {{ 'components.decision-session.decision-session-closed' | translate }}
    </mat-card>
    }
    @if (response_stamps?.completed) {
    <mat-card class="my-3" style="background-color: red; color: white;">
      {{ 'components.responses.responses-already-sent' | translate }}
    </mat-card>
    }
    }

    <mat-form-field class="col-12 col-lg-6 select-custom-button" appearance="fill">
      <mat-label>{{ 'generic.organization' | translate }}</mat-label>
      <input matInput name="organization_name" [ngModel]="organization?.name"
        placeholder="{{'generic.organization' | translate}}" readonly>
    </mat-form-field>
    <mat-form-field *appHideIfOrganization="'alexion'" class="col-12 col-lg-6 datepicker-custom-button"
      appearance="fill">
      <mat-label>{{ 'components.responses.due-date' | translate }}</mat-label>
      <input matInput name="evaluation_end"
        [ngModel]="evaluation_session?.evaluation_end != null ? (evaluation_session?.evaluation_end| formatdate | date: 'shortDate') : translate('components.responses.undefined-due-date')"
        placeholder="{{'components.responses.due-date' | translate}}" readonly>
    </mat-form-field>
  </div>
</div>

<div class="container-fluid my-1 bg-white">
  <div class="row container mx-auto">
    <div class="stepper-container col-12 my-4 pb-4">
      <div class="timeline">
        <div class="step-container">
          <div class="step">1</div>
        </div>
        <div class="step-container current">
          <div class="step">2</div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Blocco 2 -->
<div class="container-fluid accordion-container px-0 px-md-3">
  <div class="container">
    <mat-accordion class="accordion" multi>
      <mat-expansion-panel expanded>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <span class="index">2</span>
            {{ 'generic.evaluation' | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-container>
          <div class="row">
            <div class="col-12 col-lg-6 px-0 mb-0">
              <div class="box py-0 px-2 bg-transparent border-0 mb-0">
                <mat-label class="box-title px-3 mb-0">{{ 'generic.filters' | translate }}</mat-label>
              </div>
            </div>
          </div>
          <div class="row d-flex justify-content-center">
            <mat-form-field class="select-primary col-3" appearance="fill" *appShowIfOrganization="'enel,alexion'">
              <mat-label>{{ 'generic.section-filter' | translate }}</mat-label>
              <mat-select name="filter_section" [(ngModel)]="filters.section_selected"
                (selectionChange)="filterOnChange('section')">
                <mat-option value="" selected>ALL</mat-option>
                @for (sec of filters.section_filtered; track sec) {
                <mat-option [value]="sec">{{ sec }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field class="select-primary col-3" appearance="fill" *appShowIfOrganization="'enel'">
              <mat-label>{{ 'generic.subsection-filter' | translate }}</mat-label>
              <mat-select name="filter_subsection" [(ngModel)]="filters.subsection_selected"
                (selectionChange)="filterOnChange('subsection')">
                <mat-option value="" selected>ALL</mat-option>
                @for (subsec of filters.subsection_filtered; track subsec) {
                <mat-option [value]="subsec">{{ subsec }}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <section style="padding: 0.75em 0.75em 0 0.75em;">
              <mat-checkbox name="filter_only_not_answered" class="col-3" [(ngModel)]="onlyNotResponsed">{{ 'generic.only-answered' | translate }}
              </mat-checkbox>
            </section>
            <section style="padding: 0.75em 0.75em 0 0.75em;">
              <mat-checkbox name="filter_accordions_opened" class="col-3" [(ngModel)]="exandedPanels">{{ 'pages.responses.filters.show-all-open' |
                translate }}
              </mat-checkbox>
            </section>
          </div>
        </ng-container>
        <div class="row">
          @if (framework_criteria.length > 0) {
          <div class="col-12 col-lg-6 px-0 mb-0">
            <div class="box py-0 px-2 bg-transparent border-0 mb-0">
              <mat-label class="box-title px-3 mb-0">{{ 'generic.proposal' | translate }}</mat-label>
            </div>
          </div>
          }
          @for (criteria of framework_criteria; track criteria; let criteria_index = $index) {
          @if (!(onlyNotResponsed && criteriaIsCompleted(criteria)) && !criteria.hidden) {
          <div class="container-fluid accordion-container mt-3 accordion-inner rounded-0 bg-white arrow-left">
            @if (getCriteriaService().criteriaIsQualitative(criteria.typology) &&
            !getAnalysisService().isMulticriteriaByType(framework.analysis_type)) {
            <div class="container">
              <mat-accordion class="accordion" multi [togglePosition]="'before'">
                <mat-expansion-panel class="px-0" [expanded]="exandedPanels">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <span>{{ criteria.title }}</span>
                      @if (!response_stamps?.completed) {
                      <i class="icon-circle_info d-flex"></i>
                      }
                      @if (!response_stamps?.completed) {
                      <i class="icon-checkmark abs-tr mx-0" [ngClass]="getIconColorForProposalCriteria(criteria)"></i>
                      }
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  @for (proposal of criteria.proposals; track proposal; let proposal_index = $index) {
                  @if (!(onlyNotResponsed && criteriaProposalIsCompleted(proposal))) {
                  <div class="row border-bottom-grey pt-0 pb-4 my-3">
                    <small class="col-12">{{ 'generic.evaluation' | translate }} {{ proposal.title }}
                      <mat-label class="box-title px-3 mb-0 label-box">
                        @if (evaluation_session?.collecting && !decision_table?.closing_date &&
                        !response_stamps?.completed && evaluation_session.settings.review_enabled) {
                        <span class="float-right">
                          <button mat-button class="main-color" (click)="suggestProposalOnClick(proposal)">
                            <i class="icon-re_edit mr-2"></i>
                            {{ 'components.responses.revision-response' | translate }}
                          </button></span>
                        }</mat-label>
                    </small>
                    @if (proposal.evaluation_criteria) {
                    <div class="col-12">{{ proposal.evaluation_criteria.value }}
                    </div>
                    }
                    <!-- Allegati da chi ha aperto il tavolo -->
                    @if (proposal?.evaluation_criteria?.attachment?.length > 0) {
                    <div class="col-12">
                      <mat-label class="label-box font-weight-bold">
                        {{ 'components.responses.loaded-evidences' | translate }}
                      </mat-label>
                    </div>
                    }
                    @for (attachment of proposal?.evaluation_criteria?.attachment; track attachment) {
                    <div class="col-12">
                      <div class="attachment-row">
                        <span class="name">
                          <i class="icon-pdf"></i>
                          <a [href]="attachment.link" target="_blank" (click)="onClickAttachment(attachment)">{{
                            attachment.title }}</a>
                        </span>
                      </div>
                    </div>
                    }
                    @if (!proposal.evaluation_criteria.answered) {
                    <mat-slider [disabled]="response_stamps?.completed"
                      class="w-100 mt-2 tricolor cdk-focused {{ organization?.customs?.profile === 'ipsen' ? 'custom-slider' : ''}}"
                      [discrete]="true" color="primary">
                      <input matSliderThumb name="proposal_weight_{{criteria?.id}}_{{proposal?.id}}" min="0" max="100" step="1" [(ngModel)]="proposal.evaluation.weight">
                    </mat-slider>
                    }
                    @if (proposal.evaluation_criteria.answered) {
                    <mat-slider disabled
                      class="w-100 mt-2 tricolor cdk-focused {{ organization?.customs?.profile === 'ipsen' ? 'custom-slider' : ''}}"
                      [discrete]="true" color="primary">
                      <input matSliderThumb name="proposal_response_confidence_{{criteria?.id}}_{{proposal?.id}}" min="0" max="100" step="1"
                        [value]="proposal.evaluation_criteria.response.confidence">
                    </mat-slider>
                    }
                    <div class="d-flex justify-content-between w-100 mb-2 px-2">
                      <small class="float-left">{{ 'components.responses.very-low' | translate }}</small>
                      <small class="float-right">{{ 'components.responses.very-high' | translate }}</small>
                    </div>
                    <!-- <div class="col-12 mt-5" *ngIf="proposal.evaluation_criteria?.answer?.feedback != undefined"> -->
                    <div class="col-12 mt-5">
                      <mat-form-field class="full-width" appearance="fill">
                        <mat-label class="label-box font-weight-bold">
                          {{ 'generic.feedback' | translate }}
                          <!-- <i class="icon-cestino grey-color abs-tr" (click)="removeFeedback(criteria_index, proposal_index)" ></i> -->
                        </mat-label>
                        @if (!proposal.evaluation_criteria.answered) {
                        <textarea [disabled]="response_stamps?.completed" class="description my-2" required matInput
                          rows="3" [(ngModel)]="proposal.evaluation_criteria.answer.feedback"></textarea>
                        }
                        @if (proposal.evaluation_criteria.answered) {
                        <textarea disabled class="description my-2" required matInput rows="3"
                          [value]="proposal.evaluation_criteria.response.feedback"></textarea>
                        }
                      </mat-form-field>
                    </div>
                    @if (!response_stamps?.completed) {
                    <div class="col-12 links-container">
                      <!-- <button *ngIf="proposal.evaluation_criteria?.answer?.feedback == undefined" mat-button color="primary" (click)="addFeedback(criteria_index, proposal_index)">
                                      <i class="icon-Add mr-2"></i>
                                      {{'components.responses.add-feedback' | translate}}
                                    </button> -->
                      @if (!(response_stamps?.completed || decision_table?.closing_date)) {
                      <button mat-button class="allega-evidenze-btn" [matMenuTriggerFor]="menuAttachment">
                        <i class="icon-upload mr-2"></i>
                        {{ 'components.responses.add-evidences' | translate }}
                      </button>
                      }
                      <mat-menu #menuAttachment="matMenu">
                        <button mat-menu-item (click)="onClickAddNewEvidence(proposal_index, criteria_index, 'PUBMED')">
                          <mat-icon aria-hidden="false">file_upload</mat-icon>
                          Pubmed
                        </button>
                        <button mat-menu-item (click)="onClickAddNewEvidence(proposal_index, criteria_index, 'FILE')">
                          <mat-icon aria-hidden="false">file_upload</mat-icon>
                          File
                        </button>
                      </mat-menu>
                    </div>
                    }
                    @if (proposal?.evaluation_criteria?.attachment_expert?.length > 0) {
                    <div class="col-12">
                      <mat-label class="label-box font-weight-bold">
                        {{ 'components.responses.evidences-loaded-by-expert' | translate }}
                      </mat-label>
                    </div>
                    }
                    @for (attachment_expert of proposal?.evaluation_criteria?.attachment_expert; track
                    attachment_expert; let attachIndex = $index) {
                    <div class="col-12">
                      <div class="attachment-row">
                        <span class="name">
                          <i class="icon-pdf"></i>
                          <a [href]="attachment_expert.link" target="_blank">{{ attachment_expert.title }}</a>
                        </span>
                        @if (!decision_table?.closing_date && evaluation_session?.collecting &&
                        !response_stamps?.completed) {
                        <span class="size float-right">
                          {{ 'generic.buttons.delete' | translate }}
                          <i class="icon-cestino main-color"
                            (click)="onClickRemoveEvidence(attachIndex, proposal.evaluation_criteria)"></i>
                        </span>
                        }
                      </div>
                    </div>
                    }
                  </div>
                  }
                  }
                  <div class="row border-bottom-grey pt-0 pb-4 my-3">
                    <small class="col-12">{{ 'components.responses.ask-confidence' | translate }}</small>
                    <mat-slider [disabled]="response_stamps?.completed"
                      class="w-100 mt-2 cdk-focused {{ organization?.customs?.profile === 'ipsen' ? 'custom-slider' : ''}}"
                      [discrete]="true" color="primary"
                      (click)="setCriteriaAnswerConfidence(criteria.proposals[0].evaluation_criteria)">
                      <input matSliderThumb name="criteria_confidence_{{criteria?.id}}" min="0" max="100" step="1"
                        [(ngModel)]="criteria.proposals[0].evaluation_criteria.answer.confidence">
                    </mat-slider>
                    <div class="d-flex justify-content-between w-100 mb-2 px-2">
                      <small class="float-left">{{ 'components.responses.absolutely-not-sure' | translate }}</small>
                      <small class="float-right">{{ 'components.responses.absolutely-sure' | translate }}</small>
                    </div>
                  </div>
                </mat-expansion-panel>
              </mat-accordion>
            </div>
            }
            <!-- AGGIUNTO PER LA CHECKLIST -->
            @if (getAnalysisService().isMulticriteriaByType(framework.analysis_type)) {
            <div class="container">
              <mat-accordion class="accordion" multi [togglePosition]="'before'">
                <mat-expansion-panel class="px-0" [expanded]="exandedPanels">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <span>{{ criteria.title }}</span>
                      <i class="icon-circle_info text-white d-flex"></i>
                      <i class="icon-checkmark d-flex abs-tr mx-0"
                        [ngClass]="getIconColorForProposalCriteria(criteria)"></i>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  @for (proposal of criteria.proposals; track proposal; let proposal_index = $index) {
                  <div class="row border-bottom-grey pt-0 pb-4 my-3">
                    @if (proposal?.evaluation_criteria?.attachment?.length > 0) {
                    <div class="col-12 mt-3">
                      <mat-label class="label-box font-weight-bold">
                        {{ 'components.responses.loaded-evidences' | translate }}
                      </mat-label>
                    </div>
                    }
                    @for (attachment of proposal?.evaluation_criteria?.attachment; track attachment) {
                    <div class="col-12 mb-3">
                      <div class="attachment-row">
                        <span class="name">
                          <i class="icon-pdf"></i>
                          <a [href]="attachment.link" target="_blank" (click)="onClickAttachment(attachment)">{{
                            attachment.title }}</a>
                        </span>
                      </div>
                    </div>
                    }
                    <div class="row col-12" *appShowIfOrganization="'enel,alexion'">
                      <div class="col-12">
                        <mat-form-field class="input-primary" [ngClass]="{'col-4': isEnel(), 'col-12': !isEnel()}">
                          <input matInput [ngModel]="proposal.evaluation_criteria?.additional?.section"
                            placeholder="{{'generic.section' | translate}}" readonly>
                        </mat-form-field>
                        <ng-container *appHideIfOrganization="'alexion'">
                          <mat-form-field class="input-primary col-4">
                            <input matInput [ngModel]="proposal.evaluation_criteria?.additional?.sub_section"
                              [matTooltip]="proposal.evaluation_criteria?.additional?.sub_section"
                              [matTooltipPosition]="'below'" placeholder="{{'generic.sub-section' | translate}}"
                              readonly>
                          </mat-form-field>
                          <mat-form-field class="input-primary col-4">
                            <input matInput [ngModel]="proposal.evaluation_criteria?.additional?.check_n"
                              placeholder="{{'Check_n' | translate}}" readonly>
                          </mat-form-field>
                        </ng-container>
                      </div>
                      <div class="col-12" *appHideIfOrganization="'alexion'">
                        <mat-form-field class="input-primary col-4">
                          <input matInput [ngModel]="proposal.evaluation_criteria?.additional?.preliminary_check"
                            [matTooltip]="proposal.evaluation_criteria?.additional?.preliminary_check"
                            [matTooltipPosition]="'below'" placeholder="{{'generic.preliminary-check' | translate}}"
                            readonly>
                        </mat-form-field>
                        <mat-form-field class="input-primary col-4">
                          <input matInput [ngModel]="proposal.evaluation_criteria?.additional?.requirement"
                            [matTooltip]="proposal.evaluation_criteria?.additional?.requirement"
                            [matTooltipPosition]="'below'" placeholder="{{'generic.requirements' | translate}}"
                            readonly>
                        </mat-form-field>
                        <mat-form-field class="input-primary col-4">
                          <input matInput [ngModel]="proposal.evaluation_criteria?.additional?.reference"
                            placeholder="{{'generic.reference' | translate}}" readonly>
                        </mat-form-field>
                      </div>
                    </div>
                    @if (proposal.evaluation_criteria.options) {
                    <mat-radio-group [disabled]="response_stamps?.completed || decision_table?.closing_date"
                      [(ngModel)]="proposal.evaluation_criteria.answer.option_value"
                      style="display: flex; flex-direction: column; margin: 15px 0;" class="col-12">
                      @for (option of proposal.evaluation_criteria.options; track option) {
                      <mat-radio-button class="ml-1 mt-2" [value]="option.id">
                        <span style="white-space: normal">{{ option.title }}</span>
                      </mat-radio-button>
                      }
                    </mat-radio-group>
                    }
                    <div class="col-12 mt-3">
                      <mat-form-field class="full-width" appearance="fill">
                        <mat-label class="label-box font-weight-bold">
                          {{ 'generic.feedback' | translate }}
                        </mat-label>
                        <textarea [required]="!isAlexion()" class="description my-2"
                          [disabled]="decision_table?.closing_date || response_stamps?.completed" matInput rows="3"
                          [(ngModel)]="proposal.evaluation_criteria.answer.feedback"></textarea>
                      </mat-form-field>
                    </div>
                    @if (organization?.customs?.profile == 'enel') {
                    <div class="col-12">
                      <mat-form-field class="full-width" appearance="fill">
                        <mat-label class="label-box font-weight-bold">
                          {{ 'generic.draft-action' | translate }}
                        </mat-label>
                        <textarea required class="description my-2" matInput rows="3"
                          [(ngModel)]="proposal.evaluation_criteria.answer.draft_action"></textarea>
                      </mat-form-field>
                    </div>
                    }
                    @if (!(decision_table?.closing_date || response_stamps?.completed)) {
                    <div class="col-12 links-container">
                      <button mat-button class="allega-evidenze-btn" [matMenuTriggerFor]="menuAttachment">
                        <i class="icon-upload mr-2"></i>
                        {{ 'components.responses.add-evidences' | translate }}
                      </button>
                      <mat-menu #menuAttachment="matMenu">
                        <button mat-menu-item (click)="onClickAddNewEvidence(proposal_index, criteria_index, 'PUBMED')">
                          <mat-icon aria-hidden="false">file_upload</mat-icon>
                          Pubmed
                        </button>
                        <button mat-menu-item (click)="onClickAddNewEvidence(proposal_index, criteria_index, 'FILE')">
                          <mat-icon aria-hidden="false">file_upload</mat-icon>
                          File
                        </button>
                      </mat-menu>
                    </div>
                    }
                    @if (proposal?.evaluation_criteria?.attachment_expert?.length > 0) {
                    <div class="col-12">
                      <mat-label class="label-box font-weight-bold">
                        {{ 'components.responses.evidences-loaded-by-expert' | translate }}
                      </mat-label>
                    </div>
                    }
                    @for (attachment_expert of proposal?.evaluation_criteria?.attachment_expert; track
                    attachment_expert; let attachIndex = $index) {
                    <div class="col-12">
                      <div class="attachment-row">
                        <span class="name">
                          <i class="icon-pdf"></i>
                          <a [href]="attachment_expert.link" target="_blank">{{ attachment_expert.title }}</a>
                        </span>
                        @if (!decision_table?.closing_date && evaluation_session?.collecting &&
                        !response_stamps?.completed) {
                        <span class="size float-right">
                          {{ 'generic.buttons.delete' | translate }}
                          <i class="icon-cestino main-color"
                            (click)="onClickRemoveEvidence(attachIndex, proposal.evaluation_criteria)"></i>
                        </span>
                        }
                      </div>
                    </div>
                    }
                  </div>
                  }
                  <div class="row border-bottom-grey pt-0 pb-4 my-3" *appHideIfOrganization="'enel,alexion'">
                    <small class="col-12">{{ 'components.responses.ask-confidence' | translate }}</small>
                    <mat-slider
                      class="w-100 mt-2 cdk-focused {{ organization?.customs?.profile === 'ipsen' ? 'custom-slider' : ''}}"
                      [disabled]="response_stamps?.completed || decision_table?.closing_date" [discrete]="true"
                      color="primary" (click)="setCriteriaAnswerConfidence(criteria.proposals[0].evaluation_criteria)">
                      <input matSliderThumb name="criteria_confidence_{{criteria?.id}}" min="0" max="100" step="1"
                        [(ngModel)]="criteria.proposals[0].evaluation_criteria.answer.confidence">
                    </mat-slider>
                    <div class="d-flex justify-content-between w-100 mb-2 px-2">
                      <small class="float-left">{{ 'components.responses.absolutely-not-sure' | translate }}</small>
                      <small class="float-right">{{ 'components.responses.absolutely-sure' | translate }}</small>
                    </div>
                  </div>
                </mat-expansion-panel>
              </mat-accordion>
            </div>
            }
            <!-- FINE BLOCCO PER LA CHECKLIST -->
          </div>
          }
          }


          @if (evaluation_session?.collecting && !decision_table?.closing_date && !response_stamps?.completed &&
          evaluation_session.settings.provide_new_proposal_enabled) {
          <div class="col-12 links-container">
            <!-- TODO_MICHELE: aggiungere l'aggiunta di una nuova proposta solo da opzioni del tavolo decisionale -->
            <button mat-button color="primary" (click)="suggestProposalOnClick()">
              <i class="icon-Add mr-2"></i>
              {{ 'components.responses.ask-add-new-proposal' | translate }}
            </button>
            <!-- TODO_MICHELE: aggiungere la revisione delle proposte -->
            <!-- <button mat-button color="primary">
                <i class="icon-re_edit mr-2"></i>
                Vuoi revisionare le proposte?
              </button> -->
          </div>
          }

        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>


<div class="container-fluid mt-4">
  @if (!response_stamps?.completed) {
  <div class="row d-flex justify-content-center align-items-center mb-3 mx-2" *appShowIfOrganization="'alexion'">
    <mat-form-field class="mx-2" appearance="fill">
      <mat-label>{{ 'pages.task-management.component.visit-date' | translate }}</mat-label>
      <input matInput class="ng-trim-ignore" [placeholder]="'GG/MM/AAAA' | translate" required [(ngModel)]="visit_date"
        [matDatepicker]="pickerStartDate">
      <mat-datepicker-toggle matSuffix [for]="pickerStartDate"></mat-datepicker-toggle>
      <mat-datepicker #pickerStartDate></mat-datepicker>
    </mat-form-field>
  </div>
  }
  @if (!response_stamps?.completed) {
  <div class="row justify-content-center w-100 mt-0 mb-3 mx-auto">
    <button class="px-5 " matButton="filled" color="primary" [disabled]="!evaluation_session?.collecting || loading"
      (click)="isAlexion() ? verifySubmit() : verifySubmit(true)">
      @if (isAlexion()) {
      {{ 'generic.buttons.save-and-close' | translate }}
      } @else {
      {{ 'generic.buttons.save-draft' | translate }}
      }
    </button>
  </div>
  }
  <div class="row justify-content-center w-100 mt-0 mb-3 mx-auto">
    @if (response_stamps) {
    <div>
      @if (response_stamps?.completed) {
      <span> {{ 'components.responses.info-sent-date' | translate }} {{ response_stamps?.last_save| formatdate |
        date:'short' }}</span>
      }
      @if (!response_stamps?.completed) {
      <span> {{ 'components.responses.info-draft-date' | translate }} {{ response_stamps?.last_save| formatdate |
        date:'short' }}</span>
      }
    </div>
    }
  </div>
</div>


<!-- Buttons -->
@if (!response_stamps?.completed) {
<div class="buttons-container container py-4">
  <button class="button-primary float-left" mat-button [disabled]="!evaluation_session?.collecting || loading"
    [routerLink]="['../weight-criteria']">
    <i class="icon-Backward-arrow-small"></i>
    {{ 'generic.buttons.go-back' | translate }}
  </button>
  <button *appHideIfOrganization="'alexion'" class="button-primary float-right" mat-button
    [disabled]="!evaluation_session?.collecting || loading" (click)="verifySubmit()">
    <i class="icon-Forward-arrow-small"></i>{{ 'generic.buttons.save-and-send' | translate }}
  </button>
</div>
}


<!-- Parte dedicata all'aggiunta degli allegati -->

<!-- <div class="row pt-4 pb-0 my-3">
<small class="col-12">"{{'generic.evaluation' | translate}}"</small>
<div class="col-12">Rispetto dei tempi</div>
<mat-slider class="w-100 mt-2 tricolor cdk-focused" min="0" max="10" step="1" value="3" color="primary" [thumbLabel]="true"></mat-slider>
<div class="d-flex justify-content-between w-100 mb-2 px-2">
  <small class="float-left">Poco importante</small>
  <small class="float-right">Molto importante</small>
</div>

<div class="col-12 mt-5">
  <mat-label class="label-box font-weight-bold">
    Feedback
    <i class="icon-cestino grey-color abs-tr"></i>
  </mat-label>
  <p class="my-2">
    Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur.
  </p>
</div>

<div class="col-12 mt-3 ">
  <mat-label class="label-box font-weight-bold">
    Evidenze caricate
  </mat-label>

  <div class="attachment-row">
    <span class="name">
      <i class="icon-pdf"></i>
      Product_3.jpg
    </span>
    <span class="size float-right">
      12.3 MB
      <i class="icon-Cancel main-color"></i>
    </span>
  </div>

  <div class="attachment-row">
    <span class="name">
      <i class="icon-pdf"></i>
      Product_3.jpg
    </span>
    <span class="size float-right">
      12.3 MB
      <i class="icon-Cancel main-color"></i>
    </span>
  </div>

  <div class="attachment-row">
    <span class="name">
      <i class="icon-pdf"></i>
      Product_3.jpg
    </span>
    <span class="size float-right">
      12.3 MB
      <i class="icon-Cancel main-color"></i>
    </span>
  </div>

  <div class="col-12 links-container">
    <button mat-button color="primary">
      <i class="icon-upload mr-2"></i>
      {{'components.decision-table.new-decision-table.compile-proposal.load-evidences' | translate}}
    </button>
  </div>
</div>

</div> -->